import React, { useContext, useEffect, useRef, useState } from "react";
import { Badge, Button, IconButton, List, ListItem, ListItemText, Popover, Typography } from "@material-ui/core";
import EventIcon from "@material-ui/icons/Event";
import { useHistory } from "react-router-dom";
import api from "../../services/api";
import { AuthContext } from "../../context/Auth/AuthContext";

const DemoReminders = () => {
  const { user } = useContext(AuthContext);
  const history = useHistory();
  const anchor = useRef(null);
  const [open, setOpen] = useState(false);
  const [demos, setDemos] = useState([]);

  useEffect(() => {
    if (!user?.id) return;
    let active = true;
    const refresh = async () => {
      try {
        const { data } = await api.get("/demos/reminders");
        if (!active) return;
        setDemos(data);
        if ("Notification" in window && Notification.permission === "granted") {
          data.filter(demo => !demo.overdue).forEach(demo => {
            const key = `demo-reminder-${user.id}-${demo.id}-${demo.scheduledAt}`;
            if (sessionStorage.getItem(key)) return;
            sessionStorage.setItem(key, "shown");
            const notification = new Notification("Demo en los próximos 30 minutos", {
              body: `${demo.contactName} · ${demo.product || "Demo"} · ${new Date(demo.scheduledAt).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}`,
              tag: key
            });
            notification.onclick = () => { window.focus(); history.push(`/demos?demoId=${demo.id}`); notification.close(); };
          });
        }
      } catch (_) {
        // The reminder indicator remains usable when the next poll succeeds.
      }
    };
    refresh();
    const timer = window.setInterval(refresh, 60000);
    window.addEventListener("demo-saved", refresh);
    return () => { active = false; window.clearInterval(timer); window.removeEventListener("demo-saved", refresh); };
  }, [user?.id, history]);

  const handleOpen = async () => {
    setOpen(true);
    if ("Notification" in window && Notification.permission === "default") await Notification.requestPermission();
  };
  const openDemo = (demo, action) => {
    setOpen(false);
    history.push(`/demos?demoId=${demo.id}${action ? `&action=${action}` : ""}`);
  };

  return <>
    <IconButton ref={anchor} color="inherit" style={{ color: "white" }} aria-label="Recordatorios de demos" onClick={handleOpen}>
      <Badge badgeContent={demos.length} color="secondary"><EventIcon /></Badge>
    </IconButton>
    <Popover open={open} anchorEl={anchor.current} onClose={() => setOpen(false)}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }} transformOrigin={{ vertical: "top", horizontal: "right" }}>
      <div style={{ width: 320, maxHeight: 400, overflowY: "auto", padding: 12 }}>
        <Typography variant="subtitle1">Demos próximas y vencidas</Typography>
        {demos.length === 0 ? <Typography variant="body2">No tienes demos próximas ni vencidas.</Typography> :
          <List dense>{demos.map(demo => <ListItem key={demo.id} style={{ display: "block", borderBottom: "1px solid #ddd" }}>
            <ListItemText primary={`${demo.overdue ? "Vencida" : "Próxima"} · ${demo.contactName}`}
              secondary={`${demo.product || "Demo"} · ${new Date(demo.scheduledAt).toLocaleString()}`} />
            <Button size="small" onClick={() => openDemo(demo)}>Abrir</Button>
            {demo.overdue && <>
              <Button size="small" onClick={() => openDemo(demo, "done")}>Realizada</Button>
              <Button size="small" onClick={() => openDemo(demo, "canceled")}>Cancelada</Button>
              <Button size="small" onClick={() => openDemo(demo, "reschedule")}>Reprogramar</Button>
            </>}
          </ListItem>)}</List>}
      </div>
    </Popover>
  </>;
};

export default DemoReminders;
